import type {Spec} from 'immutability-helper';

import type {
  FromServerSubtemplate,
  FromServerSubtemplateVersion,
  Subtemplate,
  TemplateCollection,
  TemplateCollectionSummary,
} from 'notebook/entry-templates/TemplateConstants';
import type {SelectionRestoreData} from 'notebook/mediocre/selection/SelectionStore';
import type {CidIdMap, CidNotePartProvenanceIdMap} from 'notebook/notes/NoteConstants';
import type {MultidocTableOpMap} from 'notebook/tables/excess/ops/TableOpConstants';
import type {Response} from 'notifications';

export const SUBTEMPLATE_EVENT_PAYLOADS = {
  SUBTEMPLATE_CLOSE: {} as {subtemplateId: string},
  SUBTEMPLATE_DELETE: {} as {subtemplateId: string},
  SUBTEMPLATE_DELETE_COMPLETED: {} as {subtemplateId: string},
  SUBTEMPLATE_DELETE_FAILED: {} as {subtemplateId: string; error: Response},
  SUBTEMPLATE_FETCH_VERSIONS: {} as {subtemplateId: string},
  SUBTEMPLATE_FETCH_VERSIONS_COMPLETED: {} as {
    subtemplateId: string;
    versions: Array<FromServerSubtemplateVersion>;
    parent?: {
      name: string;
      id: string;
      versionId: number;
      modifiedAt: string;
    } | null;
  },
  SUBTEMPLATE_FETCH_VERSIONS_FAILED: {} as {subtemplateId: string},
  SUBTEMPLATE_LOAD_VERSION: {} as {subtemplateId: string; versionId: number},
  SUBTEMPLATE_LOAD_VERSION_COMPLETED: {} as {
    subtemplateId: string;
    versionId: number;
    version: FromServerSubtemplate;
  },
  SUBTEMPLATE_LOAD_VERSION_FAILED: {} as {subtemplateId: string; versionId: number},
  SUBTEMPLATE_OPEN: {} as {subtemplateId: string},
  SUBTEMPLATE_OPEN_COMPLETED: {} as {
    subtemplateId: string;
    subtemplate: FromServerSubtemplate;
    templateCollection: TemplateCollection;
  },
  SUBTEMPLATE_OPEN_FAILED: {} as {subtemplateId: string; error: Response},
  SUBTEMPLATE_REGISTER_OBJECTS: {} as {subtemplateId: string; cidIdMap: CidIdMap},
  SUBTEMPLATE_RESET_TO_OPEN_VERSION: {} as {subtemplateId: string},
  SUBTEMPLATE_REVERT: {} as {
    subtemplateId: string;
    op: Spec<Subtemplate>;
    restoreData: SelectionRestoreData | null;
    multidocTableOp: MultidocTableOpMap;
  },
  SUBTEMPLATE_SAVE: {} as {subtemplateId: string},
  SUBTEMPLATE_SAVE_COMPLETED: {} as {
    subtemplateId: string;
    savedVersion: number;
    versionId: number;
    cidIdMap: CidIdMap;
    cidNotePartProvenanceIdMap?: CidNotePartProvenanceIdMap;
    serverData: {
      editURL: string;
      templateCollection: TemplateCollectionSummary;
    };
  },
  SUBTEMPLATE_SAVE_FAILED: {} as {subtemplateId: string; error: Response},
  SUBTEMPLATE_UPDATE: {} as {
    subtemplateId: string;
    op: Spec<Subtemplate>;
    cidIdMap: CidIdMap;
    bumpVersion: boolean;
    performTableEvaluation?: boolean;
    multidocTableOp?: MultidocTableOpMap;
  },
} as const;

export type SubtemplateEventPayload = typeof SUBTEMPLATE_EVENT_PAYLOADS;
